// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import endpoints from '@tcp/core/src/services/endpoints';
import { initiateApiCall } from '@tcp/core/src/services/handler';

/**
 * Abstractor layer for checking Product List totalInventory count
 */
const Abstractor = {
  getData: ({ productIds, fields = 'productId,totalInventory,product_name' }, xappURLConfig) => {
    const formattedProductIds = Array.isArray(productIds) ? productIds.join(',') : productIds;

    const body = {
      variants: true,
      'variants.count': 0,
      promotion: false,
      version: 'V2',
      pagetype: 'boolean',
      id: formattedProductIds,
      fields,
    };

    const payload = {
      body,
      webService: endpoints.getProductDetails,
    };

    return initiateApiCall(payload, null, xappURLConfig)
      .then(Abstractor.processData)
      .catch(Abstractor.handleError);
  },

  processData: (res) => {
    if (!res.body || !res.body.response || !res.body.response.products) {
      return { products: {} };
    }

    return {
      products: res.body.response.products.reduce((acc, item) => {
        const { uniqueId, totalInventory = 0, product_name: productName } = item;
        acc[uniqueId] = { productId: uniqueId, inventoryCount: totalInventory, productName };
        return acc;
      }, {}),
    };
  },

  handleError: (error) => {
    logger.error('API Error in mediaQuickView Abstractor: ', error);
  },
};

export default Abstractor;
